<ng-container *ngLet="postSlides$ | async as postSlides">
  <div [class.eng-margin-top]="!isRuLocale"  [ngStyle]="{ 'background-color': !isRuLocale ? 'var(--secondary-10-color)' : ''}" class="facebook-container" *ngIf="postSlides && postSlides?.length > 0">
    <div *ngLet="langChange$ | async" class="content-container" >
      <div class="headline mb24">
        <div class="title">
          <svg [icon]="icons.VkBig" class="svg32 mr12" />
          <a class="overline-link facebook-title td-n primary-color" [href]="vkLink" rel="nofollow" target="_blank">{{
            'MAIN.VK' | translate
          }}</a>
        </div>

        <div>
          <a
            class="overline-link forum td-n primary-color bailout"
            [href]="vkForum"
            target="_blank"
            >{{ 'MAIN.POLLS' | translate }}</a
          >
          <a class="overline-link forum td-n primary-color" [href]="vkBoard" rel="nofollow" target="_blank">{{
            'MAIN.FORUM' | translate
          }}</a>
        </div>
      </div>
      <div class="carousel-wrapper">
        <div *ngIf="postSlides && postSlides?.length > 1" class="prev-page button-page" (selectstart)="$event.preventDefault()" (mousedown)="$event.preventDefault()" (click)="carousel.prev()">
          <svg [icon]="icons.PrevPageCarousel" class="svg32"></svg>
        </div>
        <app-carousel #carousel [autoplay]="false">
          <ng-container *ngFor="let posts of postSlides">
            <ng-container *carouselItem>
              <div class="facebook-card-wrapper">
                <app-vk-card *ngFor="let post of posts" [post]="post"></app-vk-card>
              </div>
            </ng-container>
          </ng-container>
        </app-carousel>
        <div *ngIf="postSlides && postSlides?.length > 1" class="next-page button-page" (selectstart)="$event.preventDefault()" (mousedown)="$event.preventDefault()" (click)="carousel.next()">
          <svg [icon]="icons.NextPageCarousel" class="svg32"></svg>
        </div>
      </div>
    </div>
  </div>
</ng-container>
